// extracted by mini-css-extract-plugin
export default {"container":"_1uhL","content":"Y4Zs","loading":"_2U7s"};